import { useState, useEffect } from 'react';
import { statsApi } from '../services/stats.api';
import { Trophy, Users, Send, CheckCircle2 } from 'lucide-react';
import ConversionFunnel from '../components/team/ConversionFunnel';

export default function TeamPerformance() {
  const [stats, setStats] = useState([]);
  const [statusCounts, setStatusCounts] = useState({});

  useEffect(() => {
    statsApi.team().then(r => setStats(r.data)).catch(() => {});
    statsApi.get().then(r => setStatusCounts(r.data.status_counts || {})).catch(() => {});
  }, []);

  const max = (key) => Math.max(...stats.map(s => s[key] || 0), 1);

  return (
    <div className="space-y-4">
      <h1 className="text-lg font-semibold text-zinc-900">Team Performance</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* Per-user metrics table */}
        <div className="bg-white border border-zinc-200 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-zinc-50 border-b border-zinc-200">
              <tr>
                <th className="text-left px-4 py-2.5 text-xs font-medium text-zinc-500">Name</th>
                <th className="text-right px-4 py-2.5 text-xs font-medium text-zinc-500">Assigned</th>
                <th className="text-right px-4 py-2.5 text-xs font-medium text-zinc-500">Won</th>
                <th className="text-right px-4 py-2.5 text-xs font-medium text-zinc-500">Outreach</th>
                <th className="text-right px-4 py-2.5 text-xs font-medium text-zinc-500">Tasks Done</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-100">
              {stats.map((s, i) => (
                <tr key={s.user_id} className="hover:bg-zinc-50">
                  <td className="px-4 py-3 font-medium text-zinc-800">
                    {i === 0 && <Trophy size={12} className="inline mr-1 text-yellow-500" />}
                    {s.name}
                  </td>
                  <td className="px-4 py-3 text-right text-zinc-600">{s.assigned}</td>
                  <td className="px-4 py-3 text-right">
                    <div className="flex items-center justify-end gap-2">
                      <div className="w-16 bg-zinc-100 rounded-full h-1.5">
                        <div className="bg-green-500 h-1.5 rounded-full" style={{ width: `${(s.won / max('won')) * 100}%` }} />
                      </div>
                      <span className="text-zinc-600 w-4 text-right">{s.won}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-right text-zinc-600">{s.outreach}</td>
                  <td className="px-4 py-3 text-right text-zinc-600">{s.tasks_done}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {stats.length === 0 && <p className="text-sm text-zinc-400 p-4">No data yet.</p>}
        </div>

        {/* Conversion funnel */}
        <ConversionFunnel statusCounts={statusCounts} />
      </div>
    </div>
  );
}
